/**
 * @Deprecated migrate to {@link https://github.com/VivaaHealth/vivaa/blob/master/web/patient/src/scenes/Form/FreehandBodyDiagramPage/index.tsx}
 */
import { useEffect, useState } from 'react';
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as api from '../../../api';
import { Button } from '../../../components/Button';
import BodyDiagramInput from './BodyDiagramInput';
import { parseValue } from 'common/dist/utils/types';

import styles from './index.module.css';
import './svgMap.css';
import { InfoMessage } from '../../../components/InfoMessage';
import { useParts } from '../../../hooks/common/useParts';
import { getByOrdinal, Side } from '../../../utils/enum';

interface Props extends WithTranslation {
  navigateToNextPage: () => Promise<void>;
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
  setFormField: (formFieldId: string, value: string) => void;
}

const BodyDiagramPage: React.FC<Props> = ({
  navigateToNextPage,
  field,
  setFormField,
  t,
}) => {
  const [pending, setPending] = useState(false);
  const [selected, setSelected] = useState<string[]>(
    parseValue(field.value) || [],
  );
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const onComplete = async () => {
    const stringValue = JSON.stringify(selected);
    setPending(true);
    try {
      await api.client.Previsit.updateFormField(
        field.previsitFormSetId,
        field.id,
        stringValue,
      );
      setFormField(field.id, stringValue);
      await navigateToNextPage();
    } catch (e) {
      setErrorMessage(t('Something went wrong, please try again later.'));
    }
    setPending(false);
  };
  const { part, onNext } = useParts({
    maxParts: 2,
    onComplete,
  });
  const side = getByOrdinal(Side, part);
  const bodyLocationName =
    side === Side.Front ? t('front of the body') : t('back of the body');

  useEffect(() => {
    setErrorMessage(undefined);
  }, [selected]);

  return (
    <div className={styles.PageStyle}>
      {errorMessage && <InfoMessage isError={true}>{errorMessage}</InfoMessage>}
      <div className={styles.LabelStyle}>
        {t(
          'Select the location on the {{bodyLocationName}} that you need to review.',
          {
            bodyLocationName,
          },
        )}
      </div>
      <BodyDiagramInput side={side} values={selected} onChange={setSelected} />
      <Button
        type="button"
        children={t('Continue')}
        disabled={pending}
        onClick={onNext}
      />
    </div>
  );
};

export default withTranslation()(BodyDiagramPage);
